import { appConfig } from 'config/customization';
import { topbarSize } from 'constants/sizes';
import { xsmall } from 'constants/fonts';
import Device from 'constants/deviceSizes';

export default {
  chatbox: {
    marginTop: 'auto'
  },
  chatboxImage: {
    verticalAlign: 'bottom',
    width: '100%'
  },
  utilityLinks: {
    position: 'relative',
    width: '100%',
    boxSizing: 'border-box',
    padding: '5px 15px 20px 25px',
    [Device.tablet_mobile]: {
      padding: '5px 15px 20px 25px'
    }
  },
  link: {
    color: appConfig.colors.inactiveText,
    fontSize: xsmall,
    paddingTop: 5,
    display: 'flex',
    justifyContent: 'flex-start'
  },
  containerLogo: {
    display: 'flex',
    justifyContent: 'center',
    height: topbarSize
  },
  utilityLogo: {
    height: '80%',
    cursor: 'pointer'
  }
};
